import React from 'react'

const FlightTakeOff = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' {...props}>
      <title>Flight Take Off</title>
      <path
        d='M6.05 42V39H42.05V42ZM9.2 31.6 4.05 22.85 6.2 22.45 9.7 25.55 21 22.5 12.45 8.15 15.35 7.3 29.6 20.15 40.4 17.25Q41.75 16.85 42.85 17.725Q43.95 18.6 43.95 20.05Q43.95 21 43.375 21.75Q42.8 22.5 41.9 22.75Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default React.memo(FlightTakeOff)
